import React from 'react';
import ImagemDiners from 'assets/img/icones/icon-diners.png';

const LogoDiners = props => {
  return (<img src={ImagemDiners} width="100" heigth="56" alt="Diners" style={{marginLeft: '15px'}} />)
};
export default LogoDiners;